import { useIntl } from 'react-intl'
import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import IconButton from 'LuxKit/Button/IconButton'
import Heading from 'LuxKit/Typography/Heading'
import LineMultiplyIcon from 'LuxKit/Icons/line/LineMultiplyIcon'

interface Props {
  onClose: () => void
}

function CartPanelHeader({ onClose }: Props) {
  const intl = useIntl()

  const closeLabel = intl.formatMessage({
    id: 'o0sKDEH0w6WY8j5cWs0e',
    defaultMessage: 'Close drawer',
    description: 'Aria label for the close button on the trip planner cart panel',
  })

  const title = intl.formatMessage({
    id: 'mWxW_Nn70-ovpCDsK2FG',
    defaultMessage: 'Review cart',
    description: 'Heading displayed at the top of the trip planner cart review panel',
  })

  return (
    <Sheet padding="12 16">
      <Group direction="horizontal" gap={12} verticalAlign="center">
        <IconButton
          kind="tertiary"
          size="medium"
          onClick={onClose}
          aria-label={closeLabel}
        >
          <LineMultiplyIcon />
        </IconButton>
        <Heading variant="heading4">{title}</Heading>
      </Group>
    </Sheet>
  )
}

export default CartPanelHeader
